import { useEffect, FC } from "react";
import TopNavComponent from "./TopNav";
import SideLayoutComponent from "./sideNav";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/type";
import { currentAuth } from "../../redux/firebaseState/selectors";

export type playerData = {
  playerData: [];
};
export const LayoutComponent: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { authenticated } = useSelector<RootState, RootState["auth"]>(
    currentAuth
  );

  useEffect(() => {
    if (!authenticated) {
      navigate("/", {});
    }
  }, [authenticated, navigate]);

  console.log("layout Component");
  return (
    <div className="sb-nav-fixed">
      <TopNavComponent />
      <div id="layoutSidenav">
        <SideLayoutComponent />
        <div id="layoutSidenav_content">
          <main>
            <Outlet />
          </main>
          <footer className="py-4 bg-light mt-auto">
            <div className="container-fluid px-4">
              <div className="d-flex align-items-center justify-content-between small">
                <div className="text-muted">
                  Copyright &copy; Driverman Challenge 2024
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
